import { useEffect, useState } from "react";
import api from "@/lib/api";
import ChatThread from "@/components/chat/ChatThread";
import { MessageSquare, Loader2 } from "lucide-react";

export default function ContextDiscussion({ refType, refId, attach, title = "Discussion" }) {
  const [conv, setConv] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!refId) return;
    setConv(null);
    setErr(false);
    api.get("/chat/context", { params: { ref_type: refType, ref_id: refId } })
      .then((r) => setConv(r.data))
      .catch(() => setErr(true));
  }, [refType, refId]);

  return (
    <div className="rounded-lg border border-border bg-card" data-testid="context-discussion">
      <div className="flex items-center gap-2 border-b border-border px-4 py-3">
        <MessageSquare className="h-4 w-4 text-[hsl(var(--primary))]" />
        <span className="font-heading text-base font-bold">{title}</span>
        <span className="hidden text-xs text-muted-foreground sm:inline">· team thread for this {refType}</span>
      </div>
      {!conv ? (
        <div className="flex h-40 items-center justify-center text-muted-foreground">
          {err ? "Discussion unavailable." : <Loader2 className="h-5 w-5 animate-spin" />}
        </div>
      ) : (
        <ChatThread
          conversationId={conv.id}
          defaultAttach={attach}
          heightClass="h-[420px]"
          emptyHint={`Start the discussion about this ${refType}. @mention a teammate to loop them in.`}
        />
      )}
    </div>
  );
}
